// src/common/components/CallButton/CallButton.tsx
import React from "react";
import { MdPhone } from "react-icons/md";
import styles from "./CallButton.module.scss";
import { useCallButton } from "./useCallButton";

export const CallButton: React.FC = () => {
  const { handleCall, visible } = useCallButton();

  if (!visible) return null;

  return (
    <button
      className={styles.button}
      onClick={handleCall}
      aria-label="Позвонить"
    >
      <MdPhone size={24} />
    </button>
  );
};
